<p-button 
  [styleClass]="'relative overflow-visible'"
  (click)="openWindow()" 
  size="small"
  text 
  icon="pi pi-bell" 
  title="Notifications">
  @if (messagesUnread() > 0) {
    <span
      (click)="openWindowBadgeClick($event)"
      class="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full px-0.5 min-w-[14px] h-4 flex items-center justify-center"
    >
      {{ messagesUnread() }}
    </span>
  }
</p-button>

@if (showWindow()) {
<p-card class="fixed top-[60px] p-2 right-4 z-50">

  <p-toolbar>
    <ng-template pTemplate="start">
      <p-select class="ml-1" [ngModel]="selectedSeverity()" [options]="messageTypes" (onChange)="onSeverityChange($event)"
        placeholder="All">
      </p-select>
    </ng-template>
    <ng-template pTemplate="center">
      <b>Notifications</b>
    </ng-template>
    <ng-template pTemplate="end">
      <p-button class="mr-2" size="small" outlined class="outlined-button" severity="warning" (click)="clearNotifications()"
        [disabled]="messages().length === 0">
        Clear All
      </p-button>
      <p-button size="small" severity="danger" icon="pi pi-times" (click)="closeWindow()"
        class="p-0 m-1 h-4 w-5 flex items-center justify-center">
      </p-button>
    </ng-template>
  </p-toolbar>

  <div class="hub-container">

    <div class="flex flex-col">
      @for (msg of filteredMessages(); track msg.id;) {
      <p-message [severity]="msg.severity" closable (onClose)="removeNotification(msg, $event)" class="mb-2">
        <div class="w-full">
          <span>{{msg.summary}}</span>
          <p-button class="mr-auto" rounded text size="small" severity="warning" title="Copy Message Text"
            (click)="copyNotification(msg)" icon="pi pi-clone">
          </p-button>
          <p class="text-sm">{{ msg.detail }}</p>
          <p class="text-xs">{{ msg.data.time | date: 'dd/MM/yyyy, hh:mm:ss' }}</p>
        </div>
      </p-message>
      }
    </div>

    @if (messages().length === 0) {
      <div class="flex justify-center no-notification">
        <b> No notifications to display</b>
      </div>
    }

  </div>
</p-card>
}